import {
  Button,
  CircularProgress,
  Divider,
  IconButton,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { useLocation, useNavigate } from "react-router-dom";
import {getInsuranceType as getAllInsuranceType,getInsuranceByParams} from "../../../../src/Insurance/services"
import { useEffect, useState } from "react";
import {
  initialFormData,
  MasterFormDataType,
  MasterTableDataType,
} from "./Types";
import usePopup from "../../../hooks/usePopup";
import { useMutation } from "react-query";
import { saveMasterData } from "./service";
import { clinicId } from "../../../constants";
import { FormOnChangeEventType } from "../../../EMR/types";
import { Add, Delete } from "@mui/icons-material";
import { getInsPlanService } from "../insurancePriceMaster/service";
import useAuthentication from "@hooks/useAuthentication";
const pageTitle = "Insurance Netwok";
function InsuranceNetworkAddOrEditPage() {
  const navigate = useNavigate();
  const { control, handleSubmit, reset, setValue, getValues, resetField } =
    useForm<MasterFormDataType>({
      defaultValues: initialFormData,
    });
  const {
    state: { data = null },
  } = useLocation() as { state: { data: MasterTableDataType } };
  const {user} = useAuthentication()
  const [planList, setPlanList] = useState<{ id: number; name: string }[]>([]);
  const { showSnackbar } = usePopup();
  const handleGoBack = () => {
    navigate(-1);
  };
  const [insType, setInsType] = useState<number | null>(null);
  const { mutate: getInsuranceType, data: InsuranceTypeList } =
    useMutation(getAllInsuranceType);
  const { mutate: getInsuranceByType, data: ReceiverList } = useMutation(
    getInsuranceByParams);
  const { mutate: getInsuranceByType2, data: PayerList } = useMutation(
    getInsuranceByParams);



  const { mutate: getInsurancePlan, data: insurancePlanData } = useMutation(
    getInsPlanService
  )

  const { mutate: save, isLoading } = useMutation(saveMasterData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack();
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message: e?.response?.data?.responseMessage || "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });


  const removePlan = (id: number) => {
    setPlanList((prev) => prev.filter((plan) => plan.id !== id));
  };


  const onSubmit = (value: MasterFormDataType) => {
    save([
      {
        networkCode: value.networkCode,
        networkName: value.networkName,
        insTypeId: value.insType?.id || 0,
        insNameId: value.insurance?.id || 0,
        insGroupId: value.inGroup?.id || null,
        insPlanId: planList?.map((item) => item.id as number) ?? [],
        createdById: Number(user?.userId),
        clinicId: clinicId,
        networkStatus: value.status,
        networkId: data?.networkId || 0
      },

    ]);
  };

  const addPlans = () => {
    const plan = getValues("inPlan");
    if (plan?.id) {
      const isPlanExist = planList.some((p) => p.id === plan.id);
      if (isPlanExist) {
        showSnackbar({
          message: "Plan already exists",
          open: true,
          variant: "warning",
          duration: 3000,
        });
        resetField("inPlan", { defaultValue: null });
        return;
      }
      setPlanList((prev) => [
        ...prev,
        { id: plan.id, name: plan.name },
      ]);
      resetField("inPlan", { defaultValue: null });
    } else {
      showSnackbar({
        message: "Please select a plan",
        open: true,
        variant: "warning",
        duration: 3000,
      });
      return;
    }

  };

  const OnTypeChange = (e: FormOnChangeEventType) => {
    const value = e?.target?.value;
    setInsType(value?.id);
   value?.id &&   getInsuranceByType({ typeId: value.id });
    reset({
      ...getValues(),
      insurance:null,
      inGroup:null
    })

  };
  const ReceiverChange = () => {
    getInsuranceByType2({ typeId: 2});
    getInsurancePlan({
      insType: getValues("insType")?.id as number,
      insName: getValues("insurance")?.id as number,
      clinicId: clinicId,
    })
    resetField("inGroup", { defaultValue: null });
  };

  const onpayerChange = (e: FormOnChangeEventType) => {
    const value = e?.target?.value;
    getInsurancePlan({
      insType: getValues("insType")?.id as number,
      insName: getValues("insurance")?.id as number,
      inGroupId: value?.id as number,
      clinicId: clinicId,
    });

  }



  useEffect(() => {
    getInsuranceType();
    if (data) {
      data?.insuranceType == 1
        ? (setInsType(1),
          getInsuranceByType({ typeId: 1 }),
          getInsuranceByType2({ typeId: 2}))
        : getInsuranceByType({ typeId: 2});

      reset({
        insType: data?.insuranceType ?
          {
            id: data?.insuranceType,
            name: data?.insuranceTypeName,
          }
          : null,
        networkCode: data?.networkCode || "",
        networkName: data?.networkName || "",
        status: data?.networkStatus
      });

      data?.insuranceName &&
        setValue("insurance", {
          id: data?.insuranceName as number,
          name: data?.insName as string,
        });
      setValue("inGroup", {
        id: data?.insuranceGroup as number,
        name: data?.inGroupName as string,
      });
    }
    getInsurancePlan({
      insType: data?.insuranceType as number,
      insName: data?.insuranceName as number,
      clinicId: clinicId,
    });
    setPlanList(data?.insurancePlan as { id: number; name: string }[] || []);
  }, [data]);

  return (
    <div className="p-3 ">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                Add {pageTitle}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
              >
                back
              </Button>
              <Button
                disabled={isLoading}
                color="error"
                type="reset"
                startIcon={<CloseIcon />}
                onClick={() => {
                  reset({
                    insType: null,
                    insurance: null,
                    inGroup: null,
                    inPlan: null,
                    networkCode: "",
                    networkName: "",
                    status: 1,
                  })
                }}
              >
                reset
              </Button>
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                {data ? "Update" : "Save"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">


            <CustomFormField
              control={control}
              name="networkCode"
              element="input"
              fieldProps={{ label: "Enter network code " }}
              rules={{ required: "network Code is  required" }}
            />


            <CustomFormField
              control={control}
              name="networkName"
              element="input"
              fieldProps={{ label: "Enter network Name " }}
              rules={{ required: "network Name is  required" }}
            />

            <CustomFormField
              control={control}
              name="insType"
              element="autocomplete"
              fieldProps={{ label: "InsuranceType" }}
              rules={{
                required: "Insurance is required",
                onChange: OnTypeChange,
              }}
              autocompleteProps={{
                isOptionEqualToValue: (option, value) => option.id == value.id,
                getOptionLabel: (option) => option.name,
              }}
              options={InsuranceTypeList?.response ?? []}
            />

            <CustomFormField
              control={control}
              name="insurance"
              element="autocomplete"
              fieldProps={{ label: "Receiver" }}
              rules={{
                required: "Receiver is required",
                onChange: ReceiverChange,
              }}
              options={ReceiverList?.response ?? []}
              autocompleteProps={{
                isOptionEqualToValue: (option, value) => option.id == value.id,
                getOptionLabel: (option) => option.name,
              }}
            />
            {insType == 1 && (
              <CustomFormField
                control={control}
                name="inGroup"
                element="autocomplete"
                fieldProps={{ label: "Payer" }}
                rules={{ required: false, onChange: onpayerChange }}
                options={PayerList?.response ?? []}
                autocompleteProps={{
                  isOptionEqualToValue: (option, value) =>
                    option.id == value.id,
                  getOptionLabel: (option) => option.name,
                }}
              />
            )}



            <CustomFormField
              control={control}
              name="status"
              element="radio"
              radioProps={{ row: true }}
              radios={[
                { label: "Active", value: 1 },
                { label: "Inactive", value: 0 },
              ]}
              fieldProps={{ label: "Status " }}
              rules={{ required: "Plan status is required" }}
            />

          </div>
          <div className="p-3 grid grid-cols-12 gap-3 ">
            <div className="col-span-3" >
              <CustomFormField
                control={control}
                name="inPlan"
                element="autocomplete"
                options={insurancePlanData?.response ?? []}
                fieldProps={{ label: "Enter plan Name " }}
                rules={{ required: false }}
                autocompleteProps={{
                  isOptionEqualToValue: (option, value) =>
                    option?.id == value?.id,
                  getOptionLabel: (option) => option?.name,
                  filterOptions: option => option
                }}

              />
            </div>
            <div className="col-span-9 flex justify-start items-center">
              <Button endIcon={<Add />} onClick={addPlans}>
                Add Plan
              </Button>
            </div>
            <div className="col-span-full">
              <div className="flex justify-start gap-2 items-center flex-wrap">
                {planList.map((plan) => (
                  <div className=" border-2 rounded">
                    <ListItem
                      key={plan.id}
                      secondaryAction={
                        <IconButton onClick={() => removePlan(plan.id)} color="error" edge="end" aria-label="delete">
                          <Delete />
                        </IconButton>
                      }
                    >
                      <ListItemText primary={plan.name} />
                    </ListItem>
                  </div>
                ))}
              </div>
            </div>

          </div>

        </Paper>
      </form>
    </div>
  );
}

export default InsuranceNetworkAddOrEditPage;
